import clsx from 'clsx';
import { Figure } from '../layouts';

export default function ContentBackground({ source, className }) {
  return (
    <Figure
      role="img"
      style={{ backgroundImage: `url(${source})` }}
      className={clsx(
        'absolute left-0 right-0 top-0 z-0 h-[148px] w-full bg-cover bg-center bg-no-repeat',
        className
      )}
    />
  );
}
